"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyledMenu = _interopRequireDefault(require("../../StyledMenu"));
var _NavbarLink = _interopRequireDefault(require("./NavbarLink"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavBar = _ref => {
  let {
    navbarItems,
    dropdownNavbarItems
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement("ul", {
    display: "inline",
    className: classes.navlist
  }, navbarItems.map(navbarItem => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: navbarItem.label
    }, /*#__PURE__*/_react.default.createElement(_NavbarLink.default, navbarItem));
  }), dropdownNavbarItems.map(dropdown => /*#__PURE__*/_react.default.createElement("li", {
    key: dropdown.label
  }, /*#__PURE__*/_react.default.createElement(_StyledMenu.default, {
    label: dropdown.label,
    list: dropdown.list
  }))));
};
var _default = exports.default = NavBar;